import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Лавлагаа ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Зээлийн талаарх мэдээлэл")
const _hoisted_6 = { class: "row g-10" }
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = { class: "card shadow" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user fs-5 me-3",
  style: {"color":"black"}
}, null, -1)
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row g-10" }
const _hoisted_14 = {
  key: 0,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "table table-hover table-rounded table-striped border gy-3 gs-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн төлөлтийн хэлбэр:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн хүүгийн төлөлтийн хэлбэр:", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "Олгосон зээлийн хэмжээ:", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "el-input el-input--mini" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн хүү:", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн үүсэл:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "Олгосон огноо:", -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, "Төлөгдөх огноо:", -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, "Зээл олгосон валютын нэр:", -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн зориулалт:", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, "Төлөгдсөн огноо:", -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн шимтгэлийн хувь:", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн хураамжийн хэмжээ:", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн өрийн үлдэгдэл:", -1)
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "el-input el-input--mini" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн сунгалт хийсэн огноо:", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн төлөгдөх шинэчилсэн огноо:", -1)
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн ангилал:", -1)
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", null, "Зээлийн тайлбар:", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", null, "Картын дугаар:", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash-alt fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Устгах ")
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-edit fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Засах ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Хүсэлт үүсгэх ")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Болих ")
const _hoisted_59 = {
  key: 1,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-4 my-5" }, null, -1)
const _hoisted_61 = { class: "row g-10" }
const _hoisted_62 = { class: "col-lg-12" }
const _hoisted_63 = { class: "card shadow" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-area fs-5 me-3" }),
    /*#__PURE__*/_createElementVNode("b", null, "Эргэн төлөлтийн график")
  ])
], -1)
const _hoisted_65 = { class: "card-body" }
const _hoisted_66 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_67 = {
  style: {"margin-top":"10px"},
  align: "center"
}
const _hoisted_68 = {
  key: 1,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-4 my-5" }, null, -1)
const _hoisted_70 = { class: "row g-10" }
const _hoisted_71 = { class: "col-lg-12" }
const _hoisted_72 = { class: "card shadow" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-building fs-5 me-3",
      style: {"color":"black"}
    }),
    /*#__PURE__*/_createElementVNode("b", null, "Барьцаа хөрөнгийн мэдээлэл")
  ])
], -1)
const _hoisted_74 = { class: "card-body" }
const _hoisted_75 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_76 = {
  key: 1,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-4 my-5" }, null, -1)
const _hoisted_78 = { class: "row g-10" }
const _hoisted_79 = { class: "col-lg-12" }
const _hoisted_80 = { class: "card shadow" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-users fs-5 me-3",
      style: {"color":"black"}
    }),
    /*#__PURE__*/_createElementVNode("b", null, "Хамтран зээлдэгчийн мэдээлэл")
  ])
], -1)
const _hoisted_82 = { class: "card-body" }
const _hoisted_83 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_84 = { class: "table table-hover table-rounded table-striped border gy-3 gs-3" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", null, "Хамтран зээлдэгч иргэн:", -1)
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Харах ")
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", null, "Хамтран зээлдэгч байгууллага:", -1)
const _hoisted_88 = /*#__PURE__*/_createTextVNode("Харах ")
const _hoisted_89 = {
  key: 1,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_91 = {
  key: 0,
  class: "modal fade",
  id: "getCitizenRelationInfo",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_92 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_93 = { class: "modal-content" }
const _hoisted_94 = { class: "modal-header" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("h2", null, "Холбогдох иргэний мэдээлэл", -1)
const _hoisted_96 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_97 = { class: "svg-icon svg-icon-1" }
const _hoisted_98 = { class: "modal-body" }
const _hoisted_99 = ["onClick", "data-kt-indicator"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Устгах ", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_102 = [
  _hoisted_100,
  _hoisted_101
]
const _hoisted_103 = {
  key: 1,
  class: "modal fade",
  id: "getOrgRelationInfo",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_104 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_105 = { class: "modal-content" }
const _hoisted_106 = { class: "modal-header" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("h2", null, "Холбогдох байгууллагын мэдээлэл", -1)
const _hoisted_108 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_109 = { class: "svg-icon svg-icon-1" }
const _hoisted_110 = { class: "modal-body" }
const _hoisted_111 = ["onClick", "data-kt-indicator"]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Устгах ", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_114 = [
  _hoisted_112,
  _hoisted_113
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/reference' } }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.go(-1)))
                }, "Зээлдэгчийн мэдээлэл")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h3", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("b", null, "Зээлийн талаарх мэдээлэл ~ " + _toDisplayString(this.loanDetails.lastupdate) + " ~", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (
                this.role.includes('ROLE_MORE_TLOAN') ||
                  this.role.includes('ROLE_ADMIN')
              )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (this.dataLoading)
                      ? (_openBlock(), _createBlock(_component_el_skeleton, {
                          key: 0,
                          rows: 5,
                          animated: ""
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (this.loanDetailsNotFound)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Зээлийн дэлгэрэнгүй мэдээлэл олдсонгүй. "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("table", _hoisted_16, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_17,
                                      _createElementVNode("td", null, _toDisplayString(this.requiredData.loancharttype.find(item => {
                                return (
                                  this.loanDetails.loancharttype === item.id
                                );
                              })?.value), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_18,
                                      _createElementVNode("td", null, _toDisplayString(this.requiredData.loanclass.find(item => {
                                return (
                                  this.loanDetails.interestcharttype === item.id
                                );
                              })?.value), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_19,
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(_ctx.vueNumberFormat(this.loanDetails.advamount)), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                              _createVNode(_component_VueNumberFormat, {
                                                class: "el-input__inner",
                                                value: this.updateLoanInput.advamount,
                                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((this.updateLoanInput.advamount) = $event))
                                              }, null, 8, ["value"])
                                            ])
                                          ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_23,
                                      _createElementVNode("td", null, _toDisplayString(this.loanDetails.interestinperc), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_24,
                                      _createElementVNode("td", null, _toDisplayString(this.loanDetails.source), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_25,
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(this.loanDetails.starteddate), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_27, [
                                            _createVNode(_component_el_date_picker, {
                                              size: "mini",
                                              type: "datetime",
                                              modelValue: this.updateLoanInput.starteddate,
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.updateLoanInput.starteddate) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_28,
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(this.loanDetails.expdate), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_30, [
                                            _createVNode(_component_el_date_picker, {
                                              size: "mini",
                                              modelValue: this.updateLoanInput.expdate,
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.updateLoanInput.expdate) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_31,
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(this.requiredData.currency.find(item => {
                                return (
                                  this.loanDetails.currencycode === item.id
                                );
                              })?.value), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_33, [
                                            _createVNode(_component_el_select, {
                                              modelValue: this.updateLoanInput.currencycode,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.updateLoanInput.currencycode) = $event)),
                                              size: "mini",
                                              filterable: ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.requiredData.currency, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.id,
                                                    label: item.value,
                                                    value: item.id
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_34,
                                      _createElementVNode("td", null, _toDisplayString(this.loanDetails.sector), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_35,
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(this.loanDetails.paidDate), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_37, [
                                            _createVNode(_component_el_date_picker, {
                                              size: "mini",
                                              modelValue: this.updateLoanInput.paidDate,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.updateLoanInput.paidDate) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_38,
                                      _createElementVNode("td", null, _toDisplayString(this.loanDetails.commissionperc), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_39,
                                      _createElementVNode("td", null, _toDisplayString(this.loanDetails.fee), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_40,
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString(_ctx.vueNumberFormat(this.loanDetails.balance)), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                              _createVNode(_component_VueNumberFormat, {
                                                class: "el-input__inner",
                                                value: this.updateLoanInput.balance,
                                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((this.updateLoanInput.balance) = $event))
                                              }, null, 8, ["value"])
                                            ])
                                          ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_44,
                                      _createElementVNode("td", null, _toDisplayString(this.loanDetails.extenddate), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_45,
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString(this.loanDetails.updatedexpdate), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_47, [
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: this.updateLoanInput.updatedexpdate,
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.updateLoanInput.updatedexpdate) = $event)),
                                              size: "mini"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_48,
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_49, _toDisplayString(this.requiredData.loanclass.find(item => {
                                return (
                                  this.loanDetails.loanclasscode === item.id
                                );
                              })?.value), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_50, [
                                            _createVNode(_component_el_select, {
                                              modelValue: this.updateLoanInput.loanclasscode,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.updateLoanInput.loanclasscode) = $event)),
                                              size: "mini"
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.requiredData.loanclass, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.id,
                                                    label: item.value,
                                                    value: item.id
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_51,
                                      _createElementVNode("td", null, _toDisplayString(this.loanDetails.description), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_52,
                                      _createElementVNode("td", null, _toDisplayString(this.loanDetails.cardno), 1)
                                    ])
                                  ])
                                ]),
                                (
                        this.role.includes('ROLE_UPD_DEL_TLOAN') ||
                          this.role.includes('ROLE_ADMIN')
                      )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 0,
                                            size: "mini",
                                            type: "danger",
                                            onClick: _ctx.deleteLoan
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_53,
                                              _hoisted_54
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (!this.updateLoan)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 1,
                                            size: "mini",
                                            type: "warning",
                                            onClick: _cache[9] || (_cache[9] = ($event: any) => (this.updateLoan = !this.updateLoan))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_55,
                                              _hoisted_56
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (this.updateLoan)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 2,
                                            size: "mini",
                                            type: "primary",
                                            onClick: _ctx.updateLoanAction
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_57
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (this.updateLoan)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 3,
                                            size: "mini",
                                            type: "info",
                                            onClick: _cache[10] || (_cache[10] = ($event: any) => (this.updateLoan = !this.updateLoan))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_58
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                        ], 64))
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_59, " Зээлийн дэлгэрэнгүй мэдээлэл харах эрхгүй байна. "))
            ])
          ])
        ])
      ])
    ]),
    _hoisted_60,
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("div", _hoisted_65, [
            (
              this.role.includes('ROLE_PUB_NEWS_LOAN_PAYMENT') ||
                this.role.includes('ROLE_ADMIN')
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_input_number, {
                      class: "col-sm-1",
                      modelValue: _ctx.loanPayGraphPageSize,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.loanPayGraphPageSize) = $event)),
                      onChange: _ctx.handleChange,
                      style: {"width":"15%"},
                      min: 1,
                      max: 100,
                      size: "mini"
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: 
                  this.loanPayGraph.slice(
                    this.loanPayGraphPageSize * this.loanPayGraphPage -
                      this.loanPayGraphPageSize,
                    this.loanPayGraphPageSize * this.loanPayGraphPage
                  )
                ,
                    border: "",
                    "element-loading-text": "Өгөгдөл татаж байна...",
                    "empty-text": this.emptyText,
                    size: "mini",
                    "cell-style": { textAlign: 'center' },
                    "header-cell-style": { textAlign: 'center' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "№",
                        prop: "rownum",
                        width: "50"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төлөгдөх огноо",
                        prop: "datetopay"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төлөх дүн",
                        prop: "amounttopay"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төлөх хүү",
                        prop: "amounttopay2"
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "empty-text"])), [
                    [_directive_loading, this.dataLoading]
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_pagination, {
                        layout: "total, prev, pager, next, jumper",
                        onCurrentChange: _ctx.handleCurrentChange,
                        "page-size": _ctx.loanPayGraphPageSize,
                        total: this.loanPayGraph.length
                      }, null, 8, ["onCurrentChange", "page-size", "total"])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_68, " Зээлийн төлөлтийн график харах эрхгүй байна. "))
          ])
        ])
      ])
    ]),
    _hoisted_69,
    _createElementVNode("div", _hoisted_70, [
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", _hoisted_72, [
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            (
              this.role.includes('ROLE_MORE_MORT_INFO') ||
                this.role.includes('ROLE_ADMIN')
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  _createElementVNode("div", null, [
                    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                      data: this.loanMortgage,
                      border: "",
                      size: "mini",
                      "element-loading-text": "Өгөгдөл татаж байна...",
                      "empty-text": "Өгөгдөл байхгүй байна.",
                      "cell-style": { textAlign: 'center' },
                      "header-cell-style": { textAlign: 'center' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "#",
                          width: "40px"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Хөрөнгийн дугаар",
                          prop: "uniquenumber"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Барьцаа хөрөнгийн үндсэн төрөл",
                          prop: "mrtname"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Барьцаа хөрөнгийн дэд төрөл",
                          prop: "submrtname"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Үнэлгээ хийсэн огноо",
                          prop: "dateofvaluation",
                          formatter: _ctx.$filters.formatDateYMDHMS
                        }, null, 8, ["formatter"]),
                        _createVNode(_component_el_table_column, {
                          label: "Барьцаа хөрөнгөөс барьцаалагчийн шаардлагыг хангаж болох дээд хязгаар",
                          prop: "limit",
                          formatter: _ctx.$filters.formatPrice
                        }, null, 8, ["formatter"]),
                        _createVNode(_component_el_table_column, {
                          label: "Барьцаа хөрөнгийн үнэлгээ",
                          prop: "mrtvalue",
                          formatter: _ctx.$filters.formatPrice
                        }, null, 8, ["formatter"]),
                        _createVNode(_component_el_table_column, {
                          label: "Валют",
                          width: "80px",
                          prop: "currencycode"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Барьцааг эзэмшигчийн улсын бүртгэлийн №",
                          prop: "stateregisterno"
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])), [
                      [_directive_loading, this.dataLoading]
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_76, " Барьцаа хөрөнгийн мэдээлэл харах эрхгүй байна. "))
          ])
        ])
      ])
    ]),
    _hoisted_77,
    _createElementVNode("div", _hoisted_78, [
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", _hoisted_80, [
          _hoisted_81,
          _createElementVNode("div", _hoisted_82, [
            (
              this.role.includes('ROLE_MORE_TLOAN') ||
                this.role.includes('ROLE_ADMIN')
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  _createElementVNode("div", null, [
                    _createElementVNode("table", _hoisted_84, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_85,
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_button, {
                              size: "small",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getCoCitizenOrg(true))),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#getCitizenRelationInfo"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_86
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_87,
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_button, {
                              size: "small",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getCoCitizenOrg(false))),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#getOrgRelationInfo"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_88
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_89, " Хамтран зээлдэгчийн мэдээлэл харах эрхгүй байна. ")),
            _hoisted_90
          ])
        ])
      ])
    ]),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("span", _hoisted_97, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_98, [
                _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  data: this.getCoCitizen.data,
                  border: "",
                  "element-loading-text": "Өгөгдөл татаж байна...",
                  "empty-text": "Үр дүн олдсонгүй",
                  size: "mini",
                  "cell-style": { textAlign: 'center' },
                  "header-cell-style": { textAlign: 'center' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "Д/д",
                      type: "index",
                      width: "50"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Холбогдогчийн регистерийн №",
                      prop: "registerno",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Холбогдогчийн овог",
                      prop: "lastname"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Холбогдогчийн нэр",
                      prop: "subjectname"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Үндсэн зээлдэгчийн код",
                      prop: "customercode"
                    }),
                    (
                  this.role.includes('ROLE_DEL_RELATION_CUST') ||
                    this.role.includes('ROLE_ADMIN')
                )
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          label: ""
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("button", {
                              class: "el-button el-button--primary el-button--mini",
                              size: "mini",
                              onClick: ($event: any) => (_ctx.deleteRelation(scope.row, true)),
                              "data-kt-indicator": this.deleteRelationButtonLoad
                            }, _hoisted_102, 8, _hoisted_99)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_loading, this.getCoCitizen.loader]
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _hoisted_107,
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("span", _hoisted_109, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_110, [
                _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  data: this.getCoOrg.data,
                  border: "",
                  "element-loading-text": "Өгөгдөл татаж байна...",
                  "empty-text": "Үр дүн олдсонгүй",
                  size: "mini",
                  "cell-style": { textAlign: 'center' },
                  "header-cell-style": { textAlign: 'center' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "Д/д",
                      type: "index",
                      width: "50"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Регистрийн дугаар",
                      prop: "registerno",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Холбогдох байгууллагын нэр",
                      prop: "subjectname"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Үндсэн зээлдэгчийн код",
                      prop: "customercode"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Улсын бүртгэлийн дугаар",
                      prop: "stateregisterno"
                    }),
                    (
                  this.role.includes('ROLE_DEL_RELATION_CUST') ||
                    this.role.includes('ROLE_ADMIN')
                )
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          label: ""
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("button", {
                              class: "el-button el-button--primary el-button--mini",
                              size: "mini",
                              onClick: ($event: any) => (_ctx.deleteRelation(scope.row, false)),
                              "data-kt-indicator": this.deleteRelationButtonLoad
                            }, _hoisted_114, 8, _hoisted_111)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_loading, this.getCoOrg.loader]
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}